const Layers = ({ children }: LayersProps) => {
  return <div>{children}</div>;
};

export default Layers;
